<main class="login-premium-page">
  <section class="login-premium-shell">
    <header class="login-premium-topbar glass-card">
      <div class="brand-area">
        <div class="brand-logo"><img src="/favicon.png" alt="The Gherkin Forge" /></div>
        <div class="brand-copy">
          <div class="brand-title">The Gherkin Forge</div>
          <div class="brand-subtitle">Secure sign in</div>
        </div>
      </div>

      <div class="hero-actions">
        <a class="secondary-button login-topbar-button" routerLink="/">Retour a l accueil</a>
      </div>
    </header>

    <section class="login-premium-grid">
      <section class="login-premium-hero">
        <div class="eyebrow">Authentification</div>
        <h1 class="hero-title">Connexion a votre espace.</h1>
        <p class="hero-copy login-hero-copy">
          Cette page sert uniquement a l authentification des utilisateurs, admins et superadmin.
          Aucun contenu marketing n y est affiche.
        </p>
      </section>

      <section class="login-premium-panel">
        <section class="login-card panel-card login-card-premium">
          <div class="login-card-header">
            <div>
              <div class="eyebrow">Sign in</div>
              <h2 class="subsection-title">Acceder au backoffice ou a votre workspace</h2>
            </div>
            <div class="status-pill status-pill-success">Secure access</div>
          </div>

          <form class="login-form-premium" [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <label class="field-block login-field-block">
              <span>Email ou identifiant</span>
              <input type="text" formControlName="identifier" autocomplete="username" placeholder="you@company.com" />
            </label>

            <label class="field-block login-field-block">
              <span>Mot de passe</span>
              <input
                type="password"
                formControlName="password"
                autocomplete="current-password"
                placeholder="Votre mot de passe"
              />
            </label>

            <div
              class="feedback login-feedback"
              *ngIf="feedback() as message"
              [class.feedback--error]="feedbackType() === 'error'"
            >
              {{ message }}
            </div>

            <button class="primary-button primary-button--wide login-submit-button" type="submit" [disabled]="loading()">
              {{ loading() ? 'Connexion...' : 'Se connecter' }}
            </button>

            <button
              class="secondary-button primary-button--wide login-reset-toggle-button"
              type="button"
              (click)="toggleResetPassword()"
              style="margin-top: 12px;"
            >
              {{ resetExpanded() ? 'Fermer la reinitialisation' : 'Reinitialiser mon mot de passe' }}
            </button>
          </form>

          <form
            *ngIf="resetExpanded()"
            class="login-form-premium"
            [formGroup]="resetForm"
            (ngSubmit)="submitPasswordReset()"
            novalidate
            style="margin-top: 16px; padding-top: 16px; border-top: 1px solid rgba(148, 163, 184, 0.28);"
          >
            <div class="hero-copy" style="font-size: 0.95rem; margin-bottom: 12px;">
              Utilisez l email ou l identifiant saisi ci-dessus, puis renseignez votre mot de passe actuel.
            </div>

            <label class="field-block login-field-block">
              <span>Mot de passe actuel</span>
              <input
                type="password"
                formControlName="currentPassword"
                autocomplete="current-password"
                placeholder="Votre mot de passe actuel"
              />
            </label>

            <label class="field-block login-field-block">
              <span>Nouveau mot de passe</span>
              <input
                type="password"
                formControlName="newPassword"
                autocomplete="new-password"
                placeholder="Au moins 8 caracteres"
              />
            </label>

            <label class="field-block login-field-block">
              <span>Confirmer le nouveau mot de passe</span>
              <input
                type="password"
                formControlName="confirmNewPassword"
                autocomplete="new-password"
                placeholder="Confirmez le nouveau mot de passe"
              />
            </label>

            <div
              class="feedback login-feedback"
              *ngIf="resetFeedback() as message"
              [class.feedback--error]="resetFeedbackType() === 'error'"
              [style.color]="resetFeedbackType() === 'success' ? '#166534' : null"
            >
              {{ message }}
            </div>

            <button class="primary-button primary-button--wide login-submit-button" type="submit" [disabled]="resetLoading()">
              {{ resetLoading() ? 'Mise a jour...' : 'Mettre a jour le mot de passe' }}
            </button>
          </form>
        </section>
      </section>
    </section>

    <footer class="public-legal-footer glass-card" aria-label="Legal footer">
      <div class="public-legal-footer__copy">
        <strong>{{ legalCompanyName }}</strong>
        <p>
          The Gherkin Forge website is operated by {{ legalCompanyName }} and powered by {{ legalHostingProvider }}.
        </p>
      </div>

      <nav class="public-legal-footer__links" aria-label="Legal links">
        <a class="public-legal-footer__link" [routerLink]="privacyPolicyUrl">Privacy policy</a>
        <a class="public-legal-footer__link" [routerLink]="termsOfServiceUrl">Terms of service</a>
      </nav>
    </footer>
  </section>
</main>
